export const googleReviews = [
  {
    id: 1,
    name: 'Luiza',
    sector: 'Acallento · Cafeteria',
    image: 'cases-assets/fotos/luiza.jpg',
    rating: 5,
    comment: 'Esse foi, sem dúvida, o melhor investimento que fizemos. Hoje temos total domínio sobre o negócio. Saímos do operacional, treinamos líderes e criamos protocolos. Recomendo sem hesitar.',
  },
  {
    id: 2,
    name: 'Bruna',
    sector: 'Dentista e Empresária',
    image: 'cases-assets/fotos/bruna.jpg',
    rating: 5,
    comment: 'A Prana me ensinou a ser empresária. Até hoje não sei como sobrevivemos tanto tempo sem ela.',
  },
  {
    id: 3,
    name: 'Bruno Glad',
    sector: 'Ateliê',
    image: 'cases-assets/fotos/bruno-glad.jpg',
    rating: 5,
    comment: 'Entregaram muito mais do que eu esperava. Era a energia vital que faltava pra reerguer meu negócio. Minha eterna gratidão ao Kássio, Fábio, Dri e Ana.',
  },
];
